import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as AiIcons from "react-icons/ai";
import TutorialSideData from "./TutorialSideData";
import { IconContext } from "react-icons/lib";
import { BsChevronDoubleLeft } from "react-icons/bs";

const Nav = styled.div.attrs({
  "data-aos": "fade-left",
  "data-aos-duration": "650",
  "data-aos-once": "true",
})`
  background: linear-gradient(160deg, #131314 0%, #131314 100%);
  width: 36px;
  min-height: 44px;
  position: fixed;
  border-radius: 10px 0 0 10px;
  box-shadow: -4px 4px 20px rgba(4, 4, 4, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NavIcon = styled(Link)`
  margin-right: 2rem;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: linear-gradient(180deg, #0d0d0d 0%, #0f0f10 100%);
  width: min(92vw, 300px);
  max-height: min(70vh, 420px);
  margin-top: 180px;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  right: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1050;
  cursor: pointer;
  overflow: hidden auto;
  border-radius: 12px 0 0 12px;
  box-shadow: -8px 8px 32px rgba(0, 0, 0, 0.25);

  @media (min-width: 360px) and (max-width: 760px) {
    margin-top: 260px;
  }
  @media (min-width: 761px) {
    margin-top: 210px;
  }
`;

const SidebarWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  /* Scoped scrollbar styles */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #0e0e0e;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: white;
  }
`;

const TutorialSidebar = () => {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav onClick={showSidebar}>
          <span className="text-light ms-1 mb-2 sidebar_span">
            <BsChevronDoubleLeft />
          </span>
        </Nav>

        <SidebarNav sidebar={sidebar}>
          <SidebarWrap>
            <NavIcon to="#" className="p-1">
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            <TutorialSideData closeSidebar={showSidebar} />
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </>
  );
};

export default TutorialSidebar;
